/*
 * Converts an array to a get variable style string.
 */
function arrayToGetString(array, name) {
    let string = "";
    for (let i = 0; i < array.length; i += 1) {
        string += `${name}[]=${array[i]}&`;
    }
    return string;
}

/*
 * Takes a list of exercise id's to create
 */
function printExerciseList(exercises) {
    let msgId = "";
    if (window.message_id) {
        msgId = `&message_id=${window.message_id}`;
    }

    if (exercises.length === 1) {
        window.open(`${window.route_prefix}print?exercise_id=${exercises[0]}${msgId}`);
    } else {
        window.open(`${window.route_prefix}print?${arrayToGetString(exercises, "exercise_id")}${msgId}`);
    }
}
window.printExerciseList = printExerciseList;

/*
 * ...
 */
function exerciseObjectsToIdArray(exercises) {
    const ids = [];
    for (let i = 0; i < exercises.length; i += 1) {
        ids.push(exercises[i].id);
    }
    return ids;
}
window.exerciseObjectsToIdArray = exerciseObjectsToIdArray;

/*
 * ...
 */
function printExerciseListWithoutMessage(exercises) {
    window.open(`${window.route_prefix}print?${arrayToGetString(exercises, "exercise_id")}`);
}
window.printExerciseListWithoutMessage = printExerciseListWithoutMessage;

/*
 * When the DOM with all its elements are loaded.
 */
$(function () {
    $(".print-card").on("click", function () {
        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
        } else {
            $(this).addClass("active");
        }

        const curExercises = $(".print-form .active");
        const printButton = document.getElementById("submitPrintExercises");

        if (curExercises.length === 0) {
            printButton.disabled = true;
        } else {
            printButton.disabled = false;
        }
    });

    /*
     * Submits the print menu and opens a print window.
     */
    $("#submitPrintExercises").on("click", function () {
        const exercises = $(".print-form .active");
        const idArray = [];

        for (let i = 0; i < exercises.length; i += 1) {
            const exercise = exercises[i];
            idArray.push($(exercise).data("exercise-id"));
        }

        printExerciseList(idArray);
    });
});
